import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxFormComponent, DxFormModule } from 'devextreme-angular';
import { getSizeQualifier, ScreenServiceService } from '../../shared-services/screen-service.service';
import { ApplyPipeModule } from "../../../takvim/apply.pipe";

type CardData = Record<string, any>;

@Component({
    selector: 'dk-profile-card',
    standalone: true,
    templateUrl: './profile-card.component.html',
    styleUrls: ['./profile-card.component.scss'],
    imports: [CommonModule, DxFormModule, ApplyPipeModule]
})
export class ProfileCardComponent {
  @ViewChild('form', { static: true }) form: DxFormComponent;

  @Input() items: Record<string, any>[] = [];

  @Input() colCount: number = 2;

  @Input() title: string = '';

  @Output() dataChanged = new EventEmitter<any>();

  @Input() cardData: CardData;

  getSizeQualifier = getSizeQualifier;

  assign = Object.assign;

  constructor(public screen: ScreenServiceService) {}

  onFieldChange(fieldName?:any, value?:any) {
    const {isValid} = this.form.instance.validate();

    if (!isValid) {
      return;
    }

    if (fieldName) {
      this.cardData[fieldName] = value;
    }

    this.dataChanged.emit(this.cardData);
  }

  getFieldValue(cardData:any, fieldName:any) {
    return cardData[fieldName];
  }
}
